exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".contactPage{margin-bottom:30px}.Headline{text-align:center;margin-bottom:50px}.Headline small{font-size:18px;color:#222;font-weight:400}@media (max-width: 767px){.Headline{text-align:left}}.btnSubmit{padding:8px 0;margin:5px;text-transform:uppercase;font-size:18px;font-weight:700;min-width:200px;background-color:#b6102f;border-radius:4px;color:white;border:none}.btnSubmit:hover{background-color:#F62D53 !important;cursor:pointer !important}.btnSubmit:disabled{background:#ddd !important;color:#222}@media screen and (max-width: 575px){.btnSubmit{width:100%;margin:5px 0}}.btn-text{color:black;margin-right:10px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/Containers/Pages/ContactUsPage.scss
// module id = 1075
// module chunks = 0